import { SearchDocumentType } from '../graphql/gen/types';
import { BaseAction } from './utils/baseAction';

export type SearchFilterChangedAction = BaseAction<'searchFilterChanged', { newFilters: SearchDocumentType[] }>;
export const searchFilterChanged = (newFilters: SearchDocumentType[]): SearchFilterChangedAction => ({
  type: 'searchFilterChanged',
  payload: { newFilters },
});
